/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Parent_HintInputs */



/**
* | output |
* | --- |
* | "Optionally attach this league to a meta-league." |
*
* @param {League_Parent_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_parent_hint = /** @type {((inputs?: League_Parent_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Parent_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rattacher facultativement cette ligue à une méta-ligue.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vincular opcionalmente esta liga a una meta-liga.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Vincular opcionalmente esta liga a uma meta-liga.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Allegare facoltativamente questo campionato a un meta-campionato.")
	return /** @type {LocalizedString} */ ("Optionally attach this league to a meta-league.")
});